import React from "react";

export default function FilterCard(props) {
  const { img, name, onClick, className } = props;
  return (
    <div className={`filter-card ${className}`} onClick={onClick}>
      <div className="img">
        <img src={img} alt={name} />
      </div>
      <p>{name}</p>
    </div>
  );
}
